import moment from "moment";

const today = moment().startOf("day");
const yesterday = moment()
    .startOf("day")
    .subtract(1, "day");
const firstDayCurrentWeek = moment()
    .startOf("day")
    .startOf("week");
const lastDayCurrentWeek = moment().startOf("day");
const firstDayLastWeek = moment()
    .startOf("day")
    .startOf("week")
    .subtract(1, "week");
const lastDayLastWeek = moment()
    .startOf("day")
    .endOf("week")
    .subtract(1, "week");
const sevenDayAgo = moment()
    .startOf("day")
    .subtract(6, "day");
const firstDayCurrentMonth = moment()
    .startOf("day")
    .startOf("month");
const firstDayLastMonth = moment()
    .startOf("day")
    .subtract(1, "month")
    .startOf("month");
const lastDayLastMonth = moment()
    .startOf("day")
    .subtract(1, "month")
    .endOf("month");

export function getRange(start, end) {

    const startDate = moment(start, "DD.MM.YYYY");
    const endDate = moment(end, "DD.MM.YYYY");

    if (today.isSame(startDate) && today.isSame(endDate)) {
        return "Сегодня";
    }

    if (yesterday.isSame(startDate) && yesterday.isSame(endDate)) {
        return "Вчера";
    }

    if (
        firstDayCurrentWeek.isSame(startDate) &&
        lastDayCurrentWeek.isSame(endDate)
    ) {
        return "С начала недели";
    }

    if (firstDayLastWeek.isSame(startDate) && lastDayLastWeek.isSame(endDate)) {
        return "Прошлая неделя";
    }

    if (today.isSame(startDate) && sevenDayAgo.isSame(endDate)) {
        return "Последние 7 дней";
    }

    if (firstDayCurrentMonth.isSame(startDate) && today.isSame(endDate)) {
        return "Текущий месяц";
    }

    if (
        firstDayLastMonth.isSame(startDate) &&
        lastDayLastMonth.isSame(endDate)
    ) {
        return "Прошлый месяц";
    }

    if (
        moment()
            .startOf("day")
            .subtract(1, "month")
            .isSame(startDate) &&
        today.isSame(endDate)
    ) {
        return "Последний месяц";
    }

    return `${start} - ${end}`;
}
